<div class='page traveler'>
  <div class="row justify-center center" style="padding:0 4%;">
    <pivot-tile-form [(config)]="pivot_config" style="width:40%;"></pivot-tile-form>
  </div>
  <div>
  <pivot-tile [showUI]="true" [config]="pivot_config"></pivot-tile>
  </div>
</div>

